import { createFileRoute } from '@tanstack/react-router';

import { OrganizationTab } from '@/components/settings/organization/organization-tab';
import { loadNamespaces } from '@/lib/i18n/i18n';

export const Route = createFileRoute('/_authenticated/settings/')({
  loader: () => loadNamespaces('settings'),
  staticData: {
    title: 'route.settings_organization.title',
  },
  component: OrganizationTab,
});
